import { render, staticRenderFns } from "./SortGameComponent.vue?vue&type=template&id=cbbf8aa2"
import script from "./SortGameComponent.vue?vue&type=script&lang=js"
export * from "./SortGameComponent.vue?vue&type=script&lang=js"
import style0 from "./SortGameComponent.vue?vue&type=style&index=0&id=cbbf8aa2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports